import Vue from 'vue';
import Vuex from 'vuex';
import projects from './store/modules/projects';
import users from './store/modules/users';
import orr from './store/modules/orr';
import oil from './store/modules/oil';
//import guid from '@/lib/guid';
// import Dexie from 'dexie';

// import dataSources from './store/modules/data-sources';
// import layouts from './store/modules/layouts';
// import charts from './store/modules/charts';


Vue.use(Vuex)

/**
Mutations have top be synchronous
Actions don't

**/


export default new Vuex.Store({
  modules: {
    projects,
  //  dataSources,
  //  layouts,
//    charts,
    users,
    orr,
    oil,
  },
  getters: {
    //...guid
  }
})
